export default "__VITE_ASSET__eabaa889__"